export const DEFAULT_WIDTH = 10;
export const DEFAULT_HEIGHT = 10;
export const DEFAULT_DEPTH = 10;
export const DEFAULT_RADIUS = 15;
export const DEFAULT_SIZE = 15;
export const DEFAULT_POSITION = 0;
